import script from "./RegisterConfirmationView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterConfirmationView.vue?vue&type=script&setup=true&lang=js"

import "./RegisterConfirmationView.vue?vue&type=style&index=0&id=b8113ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8113ac8"]])

export default __exports__